import React from "react";
import { Github, Linkedin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider } from "@/integrations/forms/FormProvider";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="19728" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-2">
        <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono uppercase tracking-wide w-fit">Home</Link>
        <Link to="/ServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono uppercase tracking-wide w-fit">Services</Link>
        <Link to="/OurProcessPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono uppercase tracking-wide w-fit">Our Process</Link>
        <Link to="/PlayerInquiryPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono uppercase tracking-wide w-fit">Inquiry</Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono uppercase tracking-wide w-fit block">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground border-t-2 border-primary">
      <div className="container mx-auto px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575279/img/urlfixer_logo.png" alt="UrlFixer Logo" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              DB Hockey Advancement bridges the gap between elite talent and next-level opportunities. We deliver the scouting precision and technical guidance required for junior and college success.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-foreground font-bold tracking-tight text-lg uppercase">SCOUTING NETWORK</h3>
            <MenuProvider menu_id="39" className="w-full">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-foreground font-bold tracking-tight text-lg uppercase">Social media</h3>
            <div className="flex flex-col gap-4">
              <Link to="https://github.com" newTab className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors w-fit">
                <div className="p-2 border border-border bg-card group-hover:border-primary/50 transition-colors rounded-sm">
                  <Github className="size-5" />
                </div>
                <span className="text-sm font-mono uppercase">X / TWITTER</span>
              </Link>
              
              <Link to="https://linkedin.com" newTab className="group flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors w-fit">
                <div className="p-2 border border-border bg-card group-hover:border-primary/50 transition-colors rounded-sm">
                  <Linkedin className="size-5" />
                </div>
                <span className="text-sm font-mono uppercase">LinkedIn</span>
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-foreground font-bold tracking-tight text-lg uppercase">Scouting Updates</h3>
            <p className="text-sm text-muted-foreground">
              Join our elite database for player opportunities, showcase alerts, and scouting insights.
            </p>
            <FormProvider form_id="newsletter_signup">
              <form className="space-y-3" onSubmit={e => e.preventDefault()}>
                <Input type="email" name="email" placeholder="prospect@elite.com" className="bg-card border-border focus-visible:ring-primary/50 font-mono text-sm h-10 rounded-sm" required />
                <Button type="submit" className="w-full font-mono uppercase tracking-wider text-xs font-bold h-10 rounded-sm bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
                  Enroll Now <ArrowRight className="ml-2 size-4" />
                </Button>
              </form>
            </FormProvider>
          </div>

        </div>
      </div>

      {}
      <div className="border-t border-border bg-card/30">
        <div className="container mx-auto px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-xs text-muted-foreground font-mono uppercase tracking-tight">
            © {currentYear} DB Hockey Advancement. All systems elite.
          </div>
          
          <div className="flex items-center gap-6">
            
          </div>
        </div>
      </div>
    </footer>;
}